<template>
  <div class="Tab_header">
    <!-- <el-button
      class="leftBtn"
      icon="el-icon-arrow-left"
      circle
      @click="leftmove"
    ></el-button> -->

    <div class="tabswrap">
      <div
        style="display: inline-block"
        @contextmenu="showMenu(tag, index)"
        v-for="(tag, index) in tags"
        :key="tag.name"
      >
        <el-tag
          :class="$route.path === tag.code ? 'active' : ''"
          closable
          size="medium"
          :disable-transitions="true"
          :effect="$route.path === tag.code ? 'dark' : 'plain'"
          @close="handleClose(tag, index)"
          @click="handleClick(tag)"
        >
          {{ tag.name }}
        </el-tag>
      </div>
    </div>
    <!-- <el-button icon="el-icon-arrow-right" circle @click="rightmove"></el-button> -->

    <vue-context-menu
      :contextMenuData="contextMenuData"
      @savedata="savedata"
      @deladd="deladd"
    ></vue-context-menu>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      tags: [],
      editableTabsValue: "",
      Thatitem: {},
      ThatIndex: "",
      contextMenuData: {
        menuName: "demo",
        axis: {
          x: null,
          y: null,
        },
        menulists: [
          {
            fnHandler: "savedata", // Binding events(绑定事件)
            btnName: "关闭其他", // The name of the menu option (菜单名称)
          },
//           {
//             fnHandler: "deladd",
//             btnName: "关闭所有",
//           },
        ],
      },
    };
  },
  created() {
    this.tags = this.stateTagsList;
  },
  computed: {
    ...mapState(["stateTagsList"]),
  },
  methods: {
    showMenu(item, index) {
      this.Thatitem = item;
      this.ThatIndex = index;
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      // Get the current location
      this.contextMenuData.axis = {
        x,
        y,
      };
    },
    savedata(e) {
      if (this.$router.path == this.Thatitem.code) {
        // 如果关闭的标签不是当前路由的话，不做路由跳转
        return;
      }
      this.$store.commit("emptyList", this.Thatitem);
      this.$router.push(this.Thatitem.code);
    },
    deladd(e) {
      if (this.$router.path == this.Thatitem.code) {
        // 如果关闭的标签不是当前路由的话，不做路由跳转
        return;
      }
      // this.$store.commit("emptyList"); //清空个人中心标签  暂时跟关闭其他同步
      this.$store.commit("emptyList", this.Thatitem);
      this.$router.push(this.Thatitem.code);
    },

    leftmove() {
      if (this.xxx < 0) {
        this.xxx += 1;
      }
    },
    rightmove() {
      if (this.xxx > -(this.itemlist.length + this.xxx)) {
        this.xxx -= 1;
      }
    },

    ...mapMutations({
      close: "mutationCloseTag",
    }),
    ...mapMutations({
      filterList: "filterList",
    }),
    handleClick(tag) {
      console.log("当前标签组 ", this.stateTagsList);
      console.log("tags", this.tags);
      this.$router.push(tag.code);
    },
    handleClose(tag, index) {
      if (this.tags.length === 1) {
        // 如果只有一个标签则不能关闭
        return;
      }
      this.close(tag);
      if (this.$router.path == tag.code) {
        // 如果关闭的标签不是当前路由的话，不做路由跳转
        return;
      } else {
        if (index == this.tags.length - 1) {
          // 关闭最后一个标签,则路由跳转至最后一个
          this.$router.push(this.tags[index].code);
        } else {
          // 路由跳转至下一个标签页
          if (index == 0) {
            this.$router.push(this.tags[0].code);
          } else {
            this.$router.push(this.tags[index - 1].code);
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.el-tag--medium {
  border-color: #e4e7ed !important;
  /* border-left: 1px solid #e4e7ed;
  border-radius: 8px 8px 0 0 !important;
  transition: width 1.5s linear;
  margin: 1px; */
}
.el-header {
  height: 30px !important;
  text-align: left !important;
  border-bottom: 1px solid #e4e7ed !important;
}
.Tab_header {
  border-bottom: 1px solid #e4e7ed;
  /* padding: 20px 10px 0; */
  padding: 0 10px;
  border-bottom: 2px solid #FF4D01;
}
.tabswrap {
  /* border: 1px solid #e4e7ed;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  box-sizing: border-box;
  cursor: pointer; */
  width: 80%;
  /* overflow: hidden; */
  display: table-cell;
  border-left: 1px solid #efefef;
  border-radius: 8px 0 0 0;
  overflow: hidden;
}
/* demo */
.module-list-wrap {
  width: 100%;
  overflow: hidden;
}
.module-list li {
  font-style: normal;
  display: inline-block;
  width: 100px;
}
.tagItem {
  /* height:30px; */
  border-radius: 8px 8px 0 0 !important;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

/* Tabbed Styles */
.tabbed {
  width: 80%;
  min-width: 400px;
  margin: 0 auto;
  margin-bottom: 68px;
  border-bottom: 4px solid #000;
  transition: border 250ms ease;
  overflow: hidden;
}
.el-tag--medium {
  padding: 4px 15px 6px;
  background-color: #fff;
  z-index: 2;
  position: relative;
  cursor: pointer;
  color: #777;
  text-transform: uppercase;
  font: 600 13px/20px roboto, "Open Sans", Helvetica, sans-serif;
  transition: all 250ms ease;
}
.el-tag--medium:before,
.el-tag--medium:after {
  display: block;
  content: " ";
  position: absolute;
  top: 0;
  height: 100%;
  width: 20px;
  background-color: #fff;
  transition: all 250ms ease;
}
.el-tag--medium:before {
  right: -6px;
  transform: skew(30deg, 0deg);
  box-shadow: rgba(0, 0, 0, 0.1) 3px 2px 5px,
    inset rgba(255, 255, 255, 0.09) -1px 0;
}
.el-tag--medium:after {
  left: -6px;
  transform: skew(-30deg, 0deg);
  box-shadow: rgba(0, 0, 0, 0.1) -3px 2px 5px,
    inset rgba(255, 255, 255, 0.09) 1px 0;
}
.el-tag--medium:hover,
.el-tag--medium:hover:before,
.el-tag--medium:hover:after {
  background-color: #f4f7f9;
  color: #444;
}

.Tab_header >>> .active {
  z-index: 3;
  background-color: #FF4D01;
  color: #fff;
}
.Tab_header >>> .active::after {
  background-color: #FF4D01;
  color: #fff;
}
.Tab_header >>> .active::before {
  background-color: #FF4D01;
  color: #fff;
}

/* Round Tabs */
.el-tag--medium {
  border-radius: 8px 8px 0 0;
}
.el-tag--medium:before {
  border-radius: 0 8px 0 0;
}
.el-tag--medium:after {
  border-radius: 8px 0 0 0;
}
</style>


// WEBPACK FOOTER //
// common/Tabswrap/el_tabs.vue